import { render, staticRenderFns } from "./SelectSalesType.vue?vue&type=template&id=6e6e35ed&"
import script from "./SelectSalesType.vue?vue&type=script&lang=ts&"
export * from "./SelectSalesType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e6e35ed')) {
      api.createRecord('6e6e35ed', component.options)
    } else {
      api.reload('6e6e35ed', component.options)
    }
    module.hot.accept("./SelectSalesType.vue?vue&type=template&id=6e6e35ed&", function () {
      api.rerender('6e6e35ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SalesOrder/SelectSalesType.vue"
export default component.exports